import tenantAxiosInstance from '../utils/tenantAxiosInstance';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getHomepageDetails = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `${tenant_id}/homepage`)
    .then((response) => {
      return response.data;
    });
};

const personalDetails = (tenant_id, user_id) => {
  const bodyVal =  {
    "user_id": user_id
  };
  return tenantAxiosInstance
    .post(API_URL + `${tenant_id}/user_personal_settings`,bodyVal)
    .then((response) => {
      return response.data;
    });
};
const logoDetails = (tenant_id, user_id) => {
  const bodyVal =  {
    "user_id": user_id
  };
  return tenantAxiosInstance
    .post(API_URL + `${tenant_id}/get_tenant_logo`,bodyVal)
    .then((response) => {
      return response.data;
    });
};


const removeNumber = (tenant_id, user_id, body) => {
  return tenantAxiosInstance
    .post(API_URL + `${tenant_id}/${user_id}/remove_number`, body)
    .then((response) => {
      return response.data;
    });
};

// ✅ FIX: body is already a FormData built in Customization.jsx
// Just pass it directly — do NOT rebuild FormData here
const updatePersonalDetail = (tenant_id, user_id, body) => {
  let data;
  
  if (body instanceof FormData) {
    data = body;
  } else {
    data = new FormData();
    data.append("infoval", JSON.stringify(body));
  }

  return tenantAxiosInstance
    .put(API_URL + `${tenant_id}/personal_settings`, data)
    .then((response) => {
      return response.data;
    });
};

const getCompanyBasicDetails = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `${tenant_id}/basic_details`)
    .then((response) => {
      return response.data;
    });
};

const getTeamMembers = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `${tenant_id}/team_list`)
    .then((response) => {
      return response.data;
    });
};

const deleteTeamMembers = (tenant_id, user_id) => {
  return tenantAxiosInstance
    .delete(API_URL + `${tenant_id}/delete_user/${user_id}`)
    .then((response) => {
      return response.data;
    });
};

const addTeamMembers = (body, tenant_id) => {
  return tenantAxiosInstance
    .post(API_URL + `${tenant_id}/create_user`, body)
    .then((response) => {
      return response.data;
    });
};

const getPlansBillings = () => {
  return tenantAxiosInstance
    .get(API_URL + 'plans_billings')
    .then((response) => {
      return response.data;
    });
};

const acceptTerms = (tenant_id) => {
  return tenantAxiosInstance
    .put(API_URL + `${tenant_id}/accept-terms`, { accept_status: true })
    .then((response) => {
      response?.data?.user_details?.has_accepted_terms &&
        sessionStorage.setItem('brandUser', JSON.stringify(response.data));
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error);
      throw error;
    });
};

const getAllUserOf_A_Tenant = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `get/userall/${tenant_id}`)
    .then((response) => {
      return response.data;
    });
};

const updateTenantRole = (tenant_id,user_id,role_id) => {
  return tenantAxiosInstance
    .put(API_URL + `tenant/updaterole/${user_id}/${tenant_id}`,{
       "role_id" : role_id
    })
    .then((response) => {
      return response.data;
    });
};

const removeMobile = (tenant_id,user_id,reason,bid,is_ad) => {
  return tenantAxiosInstance
    .post(API_URL + `tenant/removemobile/${tenant_id}/${user_id}`,{'reason':reason,"removed_by":bid,"ba_admin":is_ad})
    .then((response) => {
      return response.data;
    });
};

const TenantSettingService = {
  getHomepageDetails,
  personalDetails,
  getAllUserOf_A_Tenant,
  updatePersonalDetail,
  getCompanyBasicDetails,
  getTeamMembers,
  deleteTeamMembers,
  addTeamMembers,
  getPlansBillings,
  acceptTerms,
  logoDetails,
  removeMobile,
  updateTenantRole,
  removeNumber
};

export default TenantSettingService;